import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/title/twoCards.svg'
import _imports_1 from '@/assets/svg/cardExchange.svg'
import _imports_2 from '@/assets/svg/title/card-blurry.svg'
import _imports_3 from '@/assets/svg/title/card-on-btn.svg'
import _imports_4 from '@/assets/svg/title/icon2.3.svg'
import _imports_5 from '@/assets/svg/title/icon1.svg'
import _imports_6 from '@/assets/svg/title/icon2.3-large.svg'
import _imports_7 from '@/assets/svg/title/icon1-large.svg'
import _imports_8 from '@/assets/svg/title/laptop.svg'
import _imports_9 from '@/assets/svg/cloud/title-cloud-top.svg'
import _imports_10 from '@/assets/svg/cloud/cloud-2.svg'
import _imports_11 from '@/assets/svg/cloud/cloud-3.svg'
import _imports_12 from '@/assets/svg/cloud/cloud-title-mini.svg'
import _imports_13 from '@/assets/svg/cloud/cloud-title-mini-2.svg'


const _hoisted_1 = {
  class: "title-wrapper",
  id: "home"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-title-card",
  src: _imports_1
}, null, -1)
const _hoisted_3 = { class: "text-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "card-title-blurry",
  src: _imports_2
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title__text-l" }, [
  /*#__PURE__*/_createTextVNode("VDCLOUD "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "black" }, " Облачная касса ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "info-text mt-4" }, "удобный сервис для онлайн-оплаты соответствующий всем требованиям ФЗ-54", -1)
const _hoisted_7 = { class: "mt-5 w-100" }
const _hoisted_8 = { class: "position-relative d-flex w-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "card-on-btn container-m-l",
  src: _imports_3
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_24_x5yssp.js');")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Подключить")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Протестировать за 1 Р ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_24_x5yssp.js');")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Подключить")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Протестировать за 1 Р")
const _hoisted_16 = { class: "container-s" }
const _hoisted_17 = {
  class: "w-50 position-relative",
  style: {"min-width":"270px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "card-on-btn",
  src: _imports_3
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_24_x5yssp.js');")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Подключить")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Протестировать за 1 Р ")
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-4\"><div class=\"d-flex justify-content-center\"><div class=\"rounded-container w-85\"><img src=\"" + _imports_4 + "\"><p class=\"percent2and3\">2.3%</p><span>Предоставляем сниженную комиссию на поступающие платежи </span></div></div><div class=\"d-flex justify-content-center\"><div class=\"rounded-container mt-4 w-85\"><img src=\"" + _imports_5 + "\"><p class=\"za1day\">за <span> 1 </span> день</p><span>Происходит онлайн-подключение </span></div></div></div>", 1)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"container-m\"><div class=\"d-flex mt-4 w-100 align-items-center\"><div class=\"rounded-container w-100\" style=\"min-width:300px;\"><img src=\"" + _imports_4 + "\"><p class=\"percent2and3\">2.3%</p><span>Предоставляем сниженную комиссию на поступающие платежи </span></div><div class=\"rounded-container w-100 ms-5\" style=\"min-width:280px;\"><img src=\"" + _imports_5 + "\"><p class=\"za1day\">за <span> 1 </span> день</p><span>Происходит онлайн-подключение </span></div></div></div><div class=\"container-l\"><div class=\"d-flex justify-content-end position-relative w-100 mt-5\"><div class=\"rounded-container w-50\"><img src=\"" + _imports_6 + "\"><p class=\"percent2and3\">2.3%</p><span>Предоставляем сниженную комиссию на поступающие платежи</span></div></div></div>", 2)
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"container-l\"><div class=\"container-za1day\"><div class=\"rounded-container\"><img src=\"" + _imports_7 + "\"><p class=\"za1day\">за <span> 1 </span> день</p><span>Происходит онлайн-подключение </span></div></div></div><div class=\"container-m-l\"><img class=\"img-title-laptop\" src=\"" + _imports_8 + "\"><img class=\"title-cloud-top\" src=\"" + _imports_9 + "\"><img class=\"title-cloud-left\" src=\"" + _imports_10 + "\"><img class=\"title-cloud-right\" src=\"" + _imports_11 + "\"></div><div class=\"container-s\"><img class=\"img-title-cloud-top-s\" src=\"" + _imports_12 + "\"><img class=\"img-title-cloud-bottom-s\" src=\"" + _imports_13 + "\"></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "img-twoCard",
      src: _imports_0,
      style: _normalizeStyle(_ctx.screenScroll ? 'z-index: 1;' : '')
    }, null, 4),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
            "data-b24-form": "click/24/x5yssp",
            "data-skip-moving": "true"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })),
          _createVNode(_component_Button, {
            class: "w-100 me-2 container-l",
            type: "success",
            size: "large",
            style: {"min-width":"310px"}
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "w-100 ms-2 container-l",
            size: "large",
            style: {"min-width":"310px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scroll('testing')))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
            "data-b24-form": "click/24/x5yssp",
            "data-skip-moving": "true"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })),
          _createVNode(_component_Button, {
            class: "w-100 me-1 container-m",
            type: "success",
            size: "medium",
            style: {"max-width":"320px","min-width":"220px"}
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "w-100 ms-1 container-m",
            size: "medium",
            style: {"max-width":"320px","min-width":"300px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scroll('testing')))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/24/x5yssp",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "mb-3 w-100",
              type: "success",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "w-100",
              size: "medium",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scroll('testing')))
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _hoisted_22
        ]),
        _hoisted_23
      ])
    ]),
    _hoisted_25
  ]))
}